import { doc, getDoc } from 'firebase/firestore';
import { firestore } from '@/services/startFirestore';
import type { EntityRecord } from '#types/System.types';

export const fetchRecord = async (
    entityId: string, recordId: string
): Promise<EntityRecord | null> => {
    const docRef = doc(firestore, `entities/${entityId}/records`, recordId);
    const snap = await getDoc(docRef);
    if (!snap.exists()) return null;
    return { docId: snap.id, ...snap.data() } as EntityRecord;
};
